import { Component } from '@angular/core';
import { GrantsService } from '../grants-list/grants.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-hero-section',
    standalone: true,
    imports: [TranslateModule, CommonModule],
    templateUrl: './hero-section.component.html',
    styleUrl: './hero-section.component.scss',
})
export class HeroSectionComponent {
    constructor(private grants: GrantsService) {}

    openDialog(): void {
        this.grants.isClickedOnStart(true);
    }
}
